import { HttpService } from './http-service';
import { API_BASE_URL } from '../constants';
import { get } from 'svelte/store';
import { user } from '../store';

export const getUBMaxRecords = async (username, password) => {
  const result = await HttpService.send(
    `${API_BASE_URL}/sync`,
    'POST',
    {
      'Content-Type': 'application/json'
    },
    JSON.stringify({
      username: username,
      password: password
    })
  );
  return removeEmptyKeys(mapToResident(result.customers));
}

export const getUBMaxRecordsByDatabases = async (databases) => {
  const result = await HttpService.send(
    `${API_BASE_URL}/sync`,
    'POST',
    {
      'Content-Type': 'application/json'
    },
    JSON.stringify({
      databases: databases
    })
  );
  return removeEmptyKeys(mapToResident(result.customers));
}

const removeEmptyKeys = (accounts) => {
  return accounts
    .map(account => {
      let cleanAccount = {};
      Object.keys(account).forEach(key => { if (account[key]) cleanAccount[key] = account[key] });
      return cleanAccount;
    });
}

const mapToResident = (accounts) => {
  return accounts.map(account => {
    return {
      account_id: get(user).account_id,
      first_name: account.firstName,
      last_name: account.lastName,
      email_1: account.email,
      cell_1: account.cellPhone.startsWith('1-') ? account.cellPhone.slice(2) : account.cellPhone,
      home_phone: account.phone.startsWith('1-') ? account.phone.slice(2) : account.phone,
      ubmax_acc: account.billingAccount,
      house_number: account.address1,
      street: account.street1,
      city: account.city,
      state: account.state,
      postal_code: account.postalCode,
      property_type: account.customerClass,
      route: account.route,
      division: account.division ? account.division : 'NONE',
      well: account.well ? account.well : 'NONE',
      address_2: account.address2,
      unit: account.unit,
      po_box: account.poBox,
      country: account.country,
      county: account.county,
      latitude: account.latitude,
      longitude: account.longitude,
      language: 'EN'
    }
  });
}